module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.login.loggedIn) ? _c('ul', {
    staticClass: "sidebar-menu tree",
    attrs: {
      "data-widget": "tree"
    }
  }, [_c('li', {
    staticClass: "treeview menu-open",
    class: 'pageLink ' + (_vm.active == '/realtime' || _vm.active == '/map' ? 'active' : '')
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu",
    staticStyle: {
      "display": "block"
    }
  }, [(_vm.login.loggedIn && _vm.currentVille.moduleBackoffice.find(function (m) { return m.parametrageBOMenu === 'TEMPS_REEL'; }).actif) ? _c('li', {
    class: 'pageLink ' + (_vm.active == '/realtime' ? 'active' : '')
  }, [_c('router-link', {
    attrs: {
      "to": "/realtime"
    },
    on: {
      "click": function($event) {
        return _vm.closeMenu()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-caret-right"
  }), _vm._v("\n          Temps réel\n        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.login.loggedIn && _vm.currentVille.moduleBackoffice.find(function (m) { return m.parametrageBOMenu === 'PARCOURS'; }).actif) ? _c('li', {
    class: 'pageLink ' + (_vm.active == '/map' ? 'active' : '')
  }, [_c('router-link', {
    attrs: {
      "to": "/map"
    }
  }, [_c('i', {
    staticClass: "fa fa-caret-right"
  }), _vm._v("\n          Parcours\n        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.login.loggedIn && _vm.currentVille.moduleBackoffice.find(function (m) { return m.parametrageBOMenu === 'REPORTING'; }).actif) ? _c('li', {
    class: 'pageLink ' + (_vm.active == '/reporting' ? 'active' : '')
  }, [_c('router-link', {
    attrs: {
      "to": "/reporting"
    }
  }, [_c('i', {
    staticClass: "fa fa-caret-right"
  }), _vm._v("\n          Reporting\n        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.login.loggedIn && _vm.currentVille.moduleBackoffice.find(function (m) { return m.parametrageBOMenu === 'IMPLANTATION_DES_CONTENANTS'; }).actif) ? _c('li', {
    class: 'pageLink ' + (_vm.active == '/implantation_des_contenants' ? 'active' : '')
  }, [_c('router-link', {
    attrs: {
      "to": "/implantation_des_contenants"
    }
  }, [_c('i', {
    staticClass: "fa fa-caret-right"
  }), _vm._v("\n          implantation "), _c('br'), _vm._v("     contenants\n        ")])], 1) : _vm._e()])]), _vm._v(" "), (_vm.login.loggedIn && _vm.store.state.currentUser.role !== 'COLLECTIVITY_USER' && _vm.currentVille.moduleBackoffice.find(function (m) { return m.parametrageBOMenu === 'TOURNEES'; }).actif) ? _c('li', {
    class: 'pageLink ' + (_vm.active == '/tournees' ? 'active' : '')
  }, [_c('router-link', {
    attrs: {
      "to": "/tournees"
    }
  }, [_c('i', {
    staticClass: "fa fa-caret-right"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Tournées")])])], 1) : _vm._e(), _vm._v(" "), (_vm.login.loggedIn && _vm.store.state.currentUser.role !== 'COLLECTIVITY_USER' && _vm.currentVille.moduleBackoffice.find(function (m) { return m.parametrageBOMenu === 'MATERIELS'; }).actif) ? _c('li', {
    class: 'pageLink ' + (_vm.active == '/materiels' ? 'active' : '')
  }, [_c('router-link', {
    attrs: {
      "to": "/materiels"
    }
  }, [_c('i', {
    staticClass: "fa fa-caret-right"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Matériels")])])], 1) : _vm._e(), _vm._v(" "), (_vm.login.loggedIn && _vm.store.state.currentUser.role !== 'COLLECTIVITY_USER' && _vm.currentVille.moduleBackoffice.find(function (m) { return m.parametrageBOMenu === 'MAITRISES'; }).actif) ? _c('li', {
    class: 'pageLink ' + (_vm.active == '/maitrises' ? 'active' : '')
  }, [_c('router-link', {
    attrs: {
      "to": "/maitrises"
    }
  }, [_c('i', {
    staticClass: "fa fa-caret-right"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Maîtrises")])])], 1) : _vm._e(), _vm._v(" "), (_vm.login.loggedIn && _vm.store.state.currentUser.role !== 'COLLECTIVITY_USER' && _vm.currentVille.moduleBackoffice.find(function (m) { return m.parametrageBOMenu === 'CANTONNIERS'; }).actif) ? _c('li', {
    class: 'pageLink ' + (_vm.active == '/cantonniers' ? 'active' : '')
  }, [_c('router-link', {
    attrs: {
      "to": "/cantonniers"
    }
  }, [_c('i', {
    staticClass: "fa fa-caret-right"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Cantonniers")])])], 1) : _vm._e(), _vm._v(" "), (_vm.login.loggedIn && _vm.store.state.currentUser.role !== 'COLLECTIVITY_USER' && _vm.currentVille.moduleBackoffice.find(function (m) { return m.parametrageBOMenu === 'SECTEURS'; }).actif) ? _c('li', {
    class: 'pageLink ' + (_vm.active == '/secteurs' ? 'active' : '')
  }, [_c('router-link', {
    attrs: {
      "to": "/secteurs"
    }
  }, [_c('i', {
    staticClass: "fa fa-caret-right"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Secteurs")])])], 1) : _vm._e(), _vm._v(" "), (_vm.login.loggedIn && _vm.store.state.currentUser.role !== 'COLLECTIVITY_USER' && _vm.currentVille.moduleBackoffice.find(function (m) { return m.parametrageBOMenu === 'DEMANDES'; }).actif) ? _c('li', {
    class: 'pageLink ' + (_vm.active == '/demandes' ? 'active' : '')
  }, [_c('router-link', {
    attrs: {
      "to": "/demandes"
    }
  }, [_c('i', {
    staticClass: "fa fa-caret-right"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Demandes")])])], 1) : _vm._e(), _vm._v(" "), (_vm.login.loggedIn && _vm.currentVille.moduleBackoffice.find(function (m) { return m.parametrageBOMenu === 'CONTENANTS'; }).actif) ? _c('li', {
    class: 'pageLink ' + (_vm.active == '/contenants' ? 'active' : '')
  }, [_c('router-link', {
    attrs: {
      "to": "/contenants"
    }
  }, [_c('i', {
    staticClass: "fa fa-caret-right"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Contenants")])])], 1) : _vm._e(), _vm._v(" "), (_vm.login.loggedIn && _vm.store.state.currentUser.role === 'ADMIN') ? _c('li', {
    staticClass: "treeview menu-open",
    class: 'pageLink ' + (_vm.active == '/administration_users' || _vm.active == '/administration_modules' || _vm.active == '/administration_anomalies' || _vm.active == '/administration_statistiques' ? 'active' : '')
  }, [_vm._m(1), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu",
    staticStyle: {
      "display": "block"
    }
  }, [_c('li', {
    class: 'pageLink ' + (_vm.active == '/administration_users' ? 'active' : '')
  }, [_c('router-link', {
    attrs: {
      "to": "/administration_users"
    },
    on: {
      "click": function($event) {
        return _vm.closeMenu()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-caret-right"
  }), _vm._v("\n          Administration "), _c('br'), _vm._v(" des utilisateurs\n        ")])], 1), _vm._v(" "), _c('li', {
    class: 'pageLink ' + (_vm.active == '/administration_modules' ? 'active' : '')
  }, [_c('router-link', {
    attrs: {
      "to": "/administration_modules"
    }
  }, [_c('i', {
    staticClass: "fa fa-caret-right"
  }), _vm._v("\n          Administration BO\n        ")])], 1), _vm._v(" "), _c('li', {
    class: 'pageLink ' + (_vm.active == '/administration_anomalies' ? 'active' : '')
  }, [_c('router-link', {
    attrs: {
      "to": "/administration_anomalies"
    }
  }, [_c('i', {
    staticClass: "fa fa-caret-right"
  }), _vm._v("\n          Administration APK\n        ")])], 1), _vm._v(" "), _c('li', {
    class: 'pageLink ' + (_vm.active == '/administration_statistiques' ? 'active' : '')
  }, [_c('router-link', {
    attrs: {
      "to": "/administration_statistiques"
    }
  }, [_c('i', {
    staticClass: "fa fa-caret-right"
  }), _vm._v("\n          KPI'S\n        ")])], 1)])]) : _vm._e(), _vm._v(" "), _c('li', {
    class: 'pageLink ' + (_vm.active == '/rgpd' ? 'active' : '')
  }, [_c('router-link', {
    attrs: {
      "to": "/rgpd"
    }
  }, [_c('i', {
    staticClass: "fa fa-caret-right"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Politique de "), _c('br'), _vm._v("        confidentialité")])])], 1), _vm._v(" "), _c('li', {
    attrs: {
      "id": "logout-menu"
    }
  }, [_c('button', {
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("Se déconnecter")])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "no-events",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-caret-right"
  }), _vm._v(" "), _c('span', [_vm._v("Cartes")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "no-events",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-caret-right"
  }), _vm._v(" "), _c('span', [_vm._v("Administration")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4324362d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SidebarMenu.vue
// module id = 2100
// module chunks = 2